export default __webpack_public_path__ + "static/media/img-0677-bosnia-full-face.120a60a9.png";